import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class AnalyticsService {
  constructor(private _http: HttpClient) {}

  public trackStatusPageView(slug: string) {
    return this._http
      .post(`${environment.baseUrl}/api/v1/analytics/status-page-view/${slug}`, {})
      .subscribe({ error: () => {} });
  }
}
